<template>
	<div class="tools">
		<v-layout row wrap fill-height>
			<v-flex xs12 class="menu-column hidden-xs-and-down">
				<Header />
			</v-flex>

			<v-flex xs12 class="div-container-actions-card">

				<v-card elevation="0" class="div-cards-links">
					<p>Gerador de links</p>
					<v-form ref="form" v-model="valid" lazy-validation>
						<v-text-field v-model="linkAdvertiser" :rules="rules.domain" label="Link da loja" required
							outline style="max-width: 600px;" />
						<v-layout row wrap>
							<v-flex xs12 sm12 md12>
								<div class="div-input-generator-link" style="max-width: 600px;">
									<a :href="linkShortedForAnnounce" target="_blank"
										v-if="linkShortedForAnnounce.length">
										{{ linkShortedForAnnounce }}
									</a>
									<v-btn v-show="linkShortedForAnnounce.length && !showCopied" icon
										@click="handleSubmitCopied" v-clipboard:copy="linkShortedForAnnounce"
										class="button-copy-link">
										<v-icon>file_copy</v-icon>
									</v-btn>
									<div class="div-text-copied" v-if="showCopied">
										<p>Copiado</p>
									</div>
								</div>
							</v-flex>
							<v-flex xs12 sm12 md12>
								<button :disabled="!valid || linkAdvertiser.length == 0"
									v-on:click="handlesubmitGeneratorLink" class="button-generate-link"
									v-show="!linkAdvertiser.length == 0">
									Gerar Link
								</button>
							</v-flex>
						</v-layout>
					</v-form>
				</v-card>

				<v-card elevation="0" class="div-cards-links">
					<p>Encurtador de links</p>
					<v-form ref="form" v-model="valid" lazy-validation>
						<v-text-field v-model="generateShortedlink" :rules="rules.domain" label="Insira um link"
							required outline style="max-width: 600px;" />
						<v-layout row wrap>
							<v-flex xs12 sm12 md12>
								<div class="div-input-generator-link" style="max-width: 600px;">
									<a :href="shortedlink" target="_blank" v-if="shortedlink.length">
										{{ shortedlink }}
									</a>
									<v-btn v-show="shortedlink.length && !showCopiedShorted" icon
										@click="handleSubmitCopiedShortLink" v-clipboard:copy="shortedlink"
										class="button-copy-link">
										<v-icon>file_copy</v-icon>
									</v-btn>
									<div class="div-text-copied" v-if="showCopiedShorted">
										<p>Copiado</p>
									</div>
								</div>
							</v-flex>
							<v-flex xs12 sm12 md12>
								<button :disabled="!valid || generateShortedlink.length == 0"
									class="button-generate-link" v-on:click="handlesubmitShortLink"
									v-show="!generateShortedlink.length == 0">
									Converter
								</button>
							</v-flex>
						</v-layout>
					</v-form>
				</v-card>

				<v-card elevation="0" class="div-cards-links">
					<p>Estatísticas dos links curto</p>
					<v-form ref="form" v-model="valid" lazy-validation>
						<v-text-field v-model="statsShortedLink" :rules="rules.shortLink"
							label="Insira o link encurtado" required outline style="max-width: 600px;" />
						<v-layout row wrap>
							<v-flex xs12 sm12 md12>
								<button :disabled="!valid || statsShortedLink.length == 0" class="button-generate-link"
									v-on:click="handlesubmitStatsShortLink" v-show="!statsShortedLink.length == 0">
									Visualizar
								</button>
							</v-flex>
							<v-flex xs12 sm12 md12 v-show="qtdVisits !== null">
								<div class="div-results-visits" style="max-width: 600px;">
									<p>Tráfego gerado</p>
									<p class="qtd-visits">{{ qtdVisits }}</p>
									<span>Quantidade de visitas</span>
								</div>
								<div class="div-results-view" style="max-width: 600px;">
									<p>Data de visualização</p>
									<div class="div-data">
										<p class="data-visits">{{ dataVisits }}</p>
										<p class="hour-visits">{{ hourVisits }}</p>
									</div>
									<span>Última visualização</span>
								</div>
							</v-flex>
						</v-layout>
					</v-form>
				</v-card>

			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import { affiliate_api } from '@/api'
import Header from '../components/Header.vue'
import validators from '@/utils/validators'

export default {
	name: 'tools',
	mixins: [affiliate_api],
	components: {
		Header
	},
	data() {
		return {
			valid: true,
			rules: {
				domain: validators.domain,
				shortLink: validators.shortLink
			},
			showCopied: false,
			showCopiedShorted: false,
			linkAdvertiser: '',
			linkForAnnounce: '',
			linkShortedForAnnounce: '',
			generateShortedlink: '',
			shortedlink: '',
			statsShortedLink: '',
			hourVisits: '',
			dataVisits: '',
			qtdVisits: null,
		}
	},
	methods: {
		validarHashNaUrl: function (url) {
			if (!url) return true;
			const hashIndex = url.indexOf('#');
			const queryIndex = url.indexOf('?');

			if (hashIndex !== -1 && (queryIndex === -1 || hashIndex < queryIndex)) {
				this.$notify({
					type: 'error',
					title: "Link com '#' não permitido. Por favor, substitua o link."
				});
				return false;
			}
			return true;
		},
		handlesubmitGeneratorLink: async function (e) {
			e.preventDefault()

			// TRAVA EXATA AQUI: Se falhar, interrompe (não converte)
			if (!this.validarHashNaUrl(this.linkAdvertiser)) return;

			if (
				!this.linkAdvertiser.includes('utm_source') &&
				!this.linkAdvertiser.includes('utm_term') &&
				!this.linkAdvertiser.includes('utm_campaign') &&
				!this.linkAdvertiser.includes('utm_medium') &&
				!this.linkAdvertiser.includes('utm_content')
			) {
				var linkBroken = this.linkAdvertiser.split('/')
				var domain = (linkBroken[0] + '//' + linkBroken[2])
				const magauserId = localStorage.getItem('magauser')
				const response = await this.generateLink(domain, magauserId)

				if (response.status === 201) {
					const { utm_term, utm_campaign } = response.data
					if (this.linkAdvertiser.includes('?')) {
						this.linkForAnnounce = `${this.linkAdvertiser}&utm_source=magafilio&utm_term=${utm_term}&utm_campaign=${utm_campaign}&utm_medium=cpa`
					} else {
						this.linkForAnnounce = `${this.linkAdvertiser}?utm_source=magafilio&utm_term=${utm_term}&utm_campaign=${utm_campaign}&utm_medium=cpa`
					}
					const linkShorted = await this.post_shorted_link(this.linkForAnnounce)
					this.linkShortedForAnnounce = linkShorted.data
				} else {
					this.linkForAnnounce = response.data.msg
					this.$notify({
						type: 'error',
						title: this.linkForAnnounce,
					})
				}
			} else {
				this.$notify({
					type: 'error',
					title: 'Link Inválido',
				})
			}
		},
		handlesubmitShortLink: async function (e) {
			e.preventDefault()

			if (!this.validarHashNaUrl(this.generateShortedlink)) return;

			const response = await this.post_shorted_link(this.generateShortedlink)
			this.shortedlink = response.data
		},
		handlesubmitStatsShortLink: async function (e) {
			e.preventDefault()
			const splitOfUrl = this.statsShortedLink.split('/')
			const code = splitOfUrl[splitOfUrl.length - 1]
			const response = await this.get_shorted_link(code)

			if (response.data._id) {
				this.qtdVisits = response.data.visits
				const dateView = response.data.updated_at.split('T')
				const [data, splitHora] = dateView
				const [hora,] = splitHora.split('.')
				const [hour, minute, seconds] = hora.split(':')
				this.hourVisits = `${String(Math.abs(hour - 3))}:${minute}:${seconds}`
				this.dataVisits = this.reverseString(data)
			} else if (response.data.message) {
				this.qtdVisits = null
				this.hourVisits = ''
				this.dataVisits = ''
				this.$notify({
					type: 'warning',
					title: response.data.message,
				})
			} else {
				this.qtdVisits = null
				this.hourVisits = ''
				this.dataVisits = ''
				this.$notify({
					type: 'error',
					title: 'Erro, informe a Magafilio!',
				})
			}
		},
		reverseString: function (str) {
			const splitData = str.split('-')
			const data = `${splitData[2]}/${splitData[1]}/${splitData[0]}`
			return data
		},
		handleSubmitCopied: function () {
			this.showCopied = true
			var interval = setInterval(() => {
				this.showCopied = false
				clearInterval(interval)
			}, 2000)
		},
		handleSubmitCopiedShortLink: function () {
			this.showCopiedShorted = true
			var interval = setInterval(() => {
				this.showCopiedShorted = false
				clearInterval(interval)
			}, 2000)
		}
	},
	watch: {
		linkAdvertiser: function () {
			this.linkForAnnounce = ''
			this.linkShortedForAnnounce = ''
		},
		generateShortedlink: function () {
			this.shortedlink = ''
		},
	}
}
</script>

<style scoped>
div.tools {
	margin: 55px 10px 95px 10px;
}

/* CONTAINER PRINCIPAL ALINHADO */
.div-container-actions-card {
	padding-left: 20px !important;
	width: 100% !important;
	max-width: 100% !important;
}

/* CARDS DE FERRAMENTAS */
.div-cards-links {
	margin-bottom: 25px;
	padding: 20px;
	border-radius: 13px !important;
}

/* DARK MODE */
.theme--dark .div-cards-links {
	background-color: #2D2F32 !important;
	box-shadow: -2px -2px 4px rgba(74, 74, 74, 0.25), 2px 2px 4px rgba(0, 0, 0, 0.25);
}

/* LIGHT MODE */
.theme--light .div-cards-links {
	background-color: #FFFFFF !important;
	box-shadow: -2px -2px 4px rgba(255, 255, 255, 1), 2px 2px 4px rgba(0, 0, 0, 0.1);
}

.div-cards-links p {
	font-size: 22px;
	line-height: 28px;
	font-weight: 600;
	margin: 0px 0px 20px 5px;
}

/* INPUT FIELDS */
.div-cards-links .v-input__slot {
	background: #FFFFFF !important;
	padding-left: 0 !important;
	padding-right: 0 !important;
}

.theme--dark .div-cards-links .v-input__slot {
	box-shadow: inset 1px 1px 2px rgba(0, 0, 0, 0.4), inset -1px -1px 2px rgba(74, 74, 74, 0.25);
}

.theme--dark .div-cards-links .v-text-field--outline fieldset {
	border-color: #757575 !important;
}

.theme--light .div-cards-links .v-input__slot {
	box-shadow: inset 1px 1px 2px rgba(0, 0, 0, 0.1), inset -1px -1px 2px rgba(255, 255, 255, 1);
}

.theme--light .div-cards-links .v-text-field--outline fieldset {
	border-color: #C6C6C6 !important;
}

/* RESULTADOS E ESTATÍSTICAS */
.div-input-generator-link {
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-radius: 65px;
	padding: 0px 14px;
	margin-bottom: 15px;
}

.theme--dark .div-input-generator-link {
	background: #2D2F32;
	box-shadow: inset -3px -3px 4px rgba(74, 74, 74, 0.25), inset 5px 5px 4px rgba(0, 0, 0, 0.25);
}

.theme--light .div-input-generator-link {
	background: #F5F5F5;
	box-shadow: inset -3px -3px 4px rgba(255, 255, 255, 1), inset 5px 5px 4px rgba(0, 0, 0, 0.1);
}

.div-input-generator-link a {
	font-size: 16px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	margin-right: 10px;
}

.div-input-generator-link .button-copy-link i {
	color: #40DA99 !important;
}

/* BOTÕES DE AÇÃO */
.button-generate-link {
	border-radius: 16px;
	padding: 6px 16px;
	background: #40DA99;
	font-weight: 500;
	margin-top: 10px;
}

.theme--dark .button-generate-link {
	box-shadow: -2px -2px 4px rgba(74, 74, 74, 0.25), 2px 2px 4px rgba(0, 0, 0, 0.25);
	color: #2D2F32 !important;
}

.theme--light .button-generate-link {
	box-shadow: -2px -2px 4px rgba(255, 255, 255, 1), 2px 2px 4px rgba(0, 0, 0, 0.1);
	color: #212121 !important;
}

.button-generate-link:hover {
	opacity: 0.6;
}

.button-generate-link:disabled {
	opacity: 0.4;
	cursor: not-allowed;
}

/* ESTATÍSTICAS */
.div-results-visits,
.div-results-view {
	border-radius: 15px;
	padding: 12px;
	margin-top: 20px;
}

.theme--dark .div-results-visits,
.theme--dark .div-results-view {
	background: #2D2F32;
	box-shadow: -2px -2px 4px rgba(74, 74, 74, 0.25), 2px 2px 4px rgba(0, 0, 0, 0.25);
}

.theme--light .div-results-visits,
.theme--light .div-results-view {
	background: #FFFFFF;
	box-shadow: -2px -2px 4px rgba(255, 255, 255, 1), 2px 2px 4px rgba(0, 0, 0, 0.1);
}

.div-results-visits p.qtd-visits,
.div-results-view p.data-visits,
.div-results-view p.hour-visits {
	color: #40DA99 !important;
}

@media(max-width: 1000px) {
	.div-container-actions-card {
		margin: auto !important;
		padding-left: 0 !important;
	}
}

@media (min-width: 600px) {

	.menu-column {
		flex: 0 0 215px !important;
		max-width: 215px !important;
	}

	.div-container-actions-card {
		flex: 1 !important;
		max-width: calc(100% - 215px) !important;
		width: auto !important;
	}
}
</style>